// extracted by mini-css-extract-plugin
export default {"Logs":"AutoScrollLogs_Logs__97Azb"};